import type { CustomerNoteCategory } from "../../notes/customerNotesApi";

export const customerNoteCategoryLabels: Record<CustomerNoteCategory, string> = {
  PRZEZMORZE: "Przezmorze",
  TRAVEL_PAY: "TravelPay",
};
